import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SearchContentInput = () => {
  const [focused, setFocused] = useState(false);
  const [searchWord, setSearchWord] = useState("");

  const searchWordClear = () => {
    setSearchWord("");
  };

  return (
    <SearchWrap>
      <SeacrchContnet>
        <p className="searchTitle">검색</p>
        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass menuIcon" />
        <StyledInput
          type="text"
          focused={focused ? 1 : 0}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder="검색"
          value={searchWord}
          onChange={(e) => {
            setSearchWord(e.target.value);
          }}
        />
        <div className="clearBtn">
          <FontAwesomeIcon icon="fa-solid fa-xmark" onClick={searchWordClear} />
        </div>
        <SearchResult>
          <p className="searchKeywordList">최근 검색 항목</p>
          <p className="searchResultMessage">최근 검색 내역 없음.</p>
        </SearchResult>
      </SeacrchContnet>
    </SearchWrap>
  );
};

export default SearchContentInput;

const SearchWrap = styled.div`
  width: 100%;
  background-color: white;
  border-left: 1px solid #eaeaea;
  opacity: 0.7;
`;

const SeacrchContnet = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;

  .searchTitle {
    padding: 20px;
    font-size: 1.5em;
    font-weight: bold;
    text-align: start;
  }

  .fa-magnifying-glass {
    position: absolute;
    left: 10%;
    top: 80px;
  }

  .clearBtn {
    width: 20px;
    height: 20px;
    background-color: #5e5e5e;
    position: absolute;
    right: 6%;
    top: 78px;
    border-radius: 50%;

    .fa-xmark {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      cursor: pointer;
    }
  }
`;

const StyledInput = styled.input.attrs((props) => ({
  focused: props.focused,
}))`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  padding: 10px 10px 10px 40px; /* 왼쪽에 아이콘 크기만큼 패딩 추가 */
  border: none;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
  transition: opacity 0.3s;
  opacity: ${(props) =>
    props.focused ? 1 : 0.8}; /* 비활성화 상태일 때 약간의 투명도 */
  background-color: ${(props) => (props.focused ? "#ffffff" : "#edecec")};
`;

const SearchResult = styled.div`
  width: 100%;
  margin-top: 10px;
  border-top: 1px solid #eaeaea;
  position: absolute;
  top: 120px;

  .searchKeywordList {
    padding: 20px;
    font-weight: bold;
  }

  .searchResultMessage {
    font-weight: bold;
    font-size: 0.8em;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 350px;
  }
`;
